import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';
import ChannelSelection from './channel';

function SetModbus() {
  const [value, setValue] = useState(10);
  const {setDisableMenu, onComponent} = useContext(MenuContext);

  const onRightHold = useCallback(() => {
    setDisableMenu(true);
    onComponent(<ChannelSelection initiallyDisableKeypress />);
    setTimeout(() => setDisableMenu(false), 500);
  }, [value]);

  return (
    <NumberView
      chars={numbers}
      focus={12}
      onChange={v => setValue(v)}
      defaultKey1={2}
      defaultKey2={2}
      defaultKey3={2}
      defaultKey4={2}
      defaultKey5={2}
      defaultKey6={2}
      defaultKey7={2}
      defaultKey8={2}
      defaultKey9={0}
      defaultKey10={0}
      defaultKey11={0}
      defaultKey12={3}
      onSave={onRightHold}
      onLeftHold={() => onComponent(<ChannelSelection initiallyDisableKeypress />)}
      title="Set Modbus Address"
      caption=""
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default SetModbus;
